export const TENANT_KEY = "xpanse_tenant"
export const HOME_TENANT_KEY = "xpanse_home_tenant"

export const normalizeTenantSlug = (value) => {
  const slug = String(value || "").trim().toLowerCase()
  if (!slug || slug.length > 63 || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug)) {
    return ""
  }
  return slug
}

export const currentTenant = () => {
  try {
    return localStorage.getItem(TENANT_KEY) || ""
  } catch (_) {
    return ""
  }
}

export const rememberTenant = (value, { home = false } = {}) => {
  const slug = normalizeTenantSlug(value)
  if (!slug) return ""
  try {
    localStorage.setItem(TENANT_KEY, slug)
    if (home) localStorage.setItem(HOME_TENANT_KEY, slug)
  } catch (_) {
    /* ignore */
  }
  return slug
}

export const workInTenant = (value) => rememberTenant(value, { home: false })
